const getOrderItemToRemove = (orderItems) => {
    return orderItems.filter(orderItem => {
        const wasRemoved = (orderItem.fulfillmentIssue === 'REPLACEMENT_ITEM' && orderItem.quantity === 0 && orderItem.deleted === true);
        const wasRemovedByCustomer = orderItem.customerAckType === 'SUBSTITUTION_REJECTED' || orderItem.customerAckType === 'NO_ANSWER_REJECTED';
        return wasRemoved || wasRemovedByCustomer;
    })
}

const getOrderItemPendingCustomerAction = (orderItems) => {
    return orderItems.filter(orderItem => orderItem.customerAckType === 'AWAITING_ACTION')
}

const getOrderItemReplacementRelatedToPendingCustomerAction = (orderItems) => {
    const pendingCustomerActionIds = new Set(getOrderItemPendingCustomerAction(orderItems).map(oi => oi.id));
    return orderItems.filter(orderItem => orderItem.fulfillmentIssueParentId && pendingCustomerActionIds.has(orderItem.fulfillmentIssueParentId));
}

const getOrderItemWithPickingAction = (orderItems) => {
    const toRemove = new Set(getOrderItemToRemove(orderItems).map(oi => oi.id));
    const pendingCustomerAction = new Set(getOrderItemReplacementRelatedToPendingCustomerAction(orderItems).map(oi => oi.id));

    return orderItems.filter(orderItem => toRemove.has(orderItem.id) || pendingCustomerAction.has(orderItem.id));
}

const getOrderItemWithIncompletePicking = (orderItems) => {
    return orderItems.filter(orderItem => !orderItem.pickingMethod && !orderItem.fulfillmentIssue);
}

export { getOrderItemToRemove, getOrderItemPendingCustomerAction, getOrderItemWithPickingAction,getOrderItemReplacementRelatedToPendingCustomerAction }